<template>
  <div>
    <div v-if="$store.state.pageLoaded">
      <h1 class="md-headline theatre-title" v-if="$store.state.selectedObject !== null">
        {{ $store.state.selectedObject.title_hr }} {{ $store.state.selectedObject.subscription_number }}
      </h1>
      <div class="theatre-container theatre-container-admin">
        <md-button class="md-icon-button md-raised md-accent back-button" title="Natrag" v-on:click="$store.dispatch('setActiveTab', 'subscriptions')">
          <md-icon>keyboard_arrow_left</md-icon>
        </md-button>
        <AdminTheatre/>
        <div v-if="getSelectedSeats.length > 0" class="selected-tickets selected-seats">
          <md-card>
            <SelectedSeats :discount="discount"/>
            <md-card-content>
              <p class="error-message">
                <span v-for="error in $store.state.errors">
                  {{ error }}<br>
                </span>
              </p>
              <p>Odabrano sjedala: <strong>{{ getSelectedSeats.length }}</strong></p>
              <p>Ukupna cijena: <strong>{{ formatCurrency(getFullPrice(discount) - custom_discount) }}</strong></p>
              <strong>Popust: </strong><md-input v-model="custom_discount" type="number"/>
              <!-- <md-checkbox v-model="discount" v-if="$store.state.receivedData.pricelists.list.length > 1 && hasDiscount">Popust na umirovljenike</md-checkbox> -->
              <md-checkbox v-model="discount" v-if="$store.state.receivedData.pricelists.list.length > 1 && hasDiscount">Popust na umirovljenike</md-checkbox>
            </md-card-content>
            <md-card-actions>
              <md-list-item>
                <md-button class="md-raised md-primary md-dense" v-on:click="setTransaction('offline_checkout', 0)">
                  Plati
                </md-button>
                <md-button class="md-raised md-primary md-dense" v-on:click="setTransaction('reservation', 0)">
                  Rezerviraj
                </md-button>
              </md-list-item>
            </md-card-actions>
          </md-card>
        </div>
      </div>
      <div>
        <Prices/>
      </div>

      <MultiTransactionDetails :fromPage="true" v-if="detailsVisible" @close="detailsVisible = false" class="details-page-inner md-scrollbar"/>

      <md-dialog :md-active.sync="steps[0]" :md-click-outside-to-close="false" :md-close-on-esc="false" class="dialog-container md-scrollbar">
        <md-dialog-title>Unesite podatke o pretplatnicima</md-dialog-title>
        <md-button class="md-icon-button md-raised md-accent back-button" title="Natrag" v-on:click="setActivePopup(null)">
          <md-icon>keyboard_arrow_left</md-icon>
        </md-button>
        <md-card>
          <md-card-content>
            <div class="user-wrapper" v-for="user, i in userData">
              <md-button class="md-icon-button md-accent back-button" title="Obriši" v-if="i > 0" v-on:click="removeSubscriber(i)">
                <md-icon>close</md-icon>
              </md-button>
              <h3 v-if="i == 0">Nositelj pretplate</h3>
              <h3 v-else>Pretplatnik</h3>
              <Autocomplete v-model="selectedSubscriber" :stateObject="'subscribers'" :searchBy="'full_name'" :label="'Odaberi pretplatnika'" v-on:click.native="populatePerson(i)"/>
                <md-field :class="messageClass('first_name', user)">
                <label>Ime</label>
                <md-input required type="text" v-model="user.first_name"/>
                <span class="md-error">Ovo polje je obavezno</span>
              </md-field>
              <md-field :class="messageClass('last_name', user)">
                <label>Prezime</label>
                <md-input required type="text" v-model="user.last_name"/>
                <span class="md-error">Ovo polje je obavezno</span>
              </md-field>
              <md-field :class="messageClass('address', user)">
                <label>Adresa</label>
                <md-input required type="text" v-model="user.address"/>
                <span class="md-error">Ovo polje je obavezno</span>
              </md-field>
              <md-field :class="messageClass('city', user)">
                <label>Grad</label>
                <md-input required type="text" v-model="user.city"/>
                <span class="md-error">Ovo polje je obavezno</span>
              </md-field>
              <md-field :class="messageClass('postal_code', user)">
                <label>Poštanski broj</label>
                <md-input required type="text" v-model="user.postal_code"/>
                <span class="md-error">Ovo polje je obavezno</span>
              </md-field>
              <md-field>
                <label>Broj telefona</label>
                <md-input type="text" v-model="user.phone"/>
              </md-field>
              <md-field :class="messageClass('mobile_phone', user)">
                <label>Broj mobitela</label>
                <md-input required type="text" v-model="user.mobile_phone"/>
                <span class="md-error">Ovo polje je obavezno</span>
              </md-field>
              <md-field>
                <label>Broj poslovnog telefona</label>
                <md-input type="text" v-model="user.work_phone"/>
              </md-field>
              <md-field :class="messageClass('email', user)">
                <label>Email</label>
                <md-input required type="email" v-model="user.email"/>
                <span class="md-error">Ovo polje je obavezno</span>
              </md-field>
            </div>
            <md-button class="md-raised md-accent md-dense add-subscriber" v-on:click="addSubscriber" v-if="userData.length <= getSelectedSeats.length - 1">
              Dodaj pretplatnika
            </md-button>
            <md-dialog-actions>
              <md-button class="md-accent md-dense md-raised" v-on:click="setActivePopup(null)">Odustani</md-button>
              <md-button class="md-primary md-dense md-raised" v-on:click="sendTransactionDetails('payment')" v-if="seatAction == 'offline_checkout'">
                Plati
              </md-button>
              <md-button class="md-primary md-dense md-raised" v-on:click="sendTransactionDetails('reservation')" v-if="seatAction == 'reservation'">
                Rezerviraj
              </md-button>
            </md-dialog-actions>
          </md-card-content>
        </md-card>
      </md-dialog>

      <md-dialog :md-active.sync="steps[1]" :md-click-outside-to-close="false" :md-close-on-esc="false" class="dialog-container md-scrollbar">
        <md-dialog-title>Način plaćanja</md-dialog-title>
        <md-button class="md-icon-button md-raised md-accent back-button" title="Natrag" v-on:click="setActivePopup(0)">
          <md-icon>keyboard_arrow_left</md-icon>
        </md-button>
        <md-card>
          <md-card-content>
            <div class="md-layout centered">
              <h4>Ukupna cijena: <strong>{{ formatCurrency(getFullPrice(discount, custom_discount)) }}</strong></h4>
              <md-radio v-model="paymentType" value="cash">Gotovina</md-radio>
              <md-radio v-model="paymentType" value="card">Kartica</md-radio>
              <md-radio v-model="paymentType" value="virman">Virman</md-radio>
              <md-checkbox v-model="r1">R1 račun</md-checkbox>
            </div>
            <div v-if="paymentType == 'card'" class="md-layout">
              <md-field>
                <label>Tip kartice</label>
                <md-select v-model="card_type">
                  <md-option value="american">American</md-option>
                  <md-option value="diners">Diners</md-option>
                  <md-option value="maestro">Maestro</md-option>
                  <md-option value="master">Master</md-option>
                  <md-option value="visa">VISA</md-option>
                  <md-option value="discovery">Discovery</md-option>
                  <md-option value="v-pay">V Pay</md-option>
                  <md-option value="union-pay">UnionPay</md-option>
                </md-select>
              </md-field>
              <md-field>
                <label>Broj rata</label>
                <md-select v-model="installments">
                <md-option value="1">1</md-option>
                <md-option value="2">2</md-option>
                <md-option value="3">3</md-option>
                <md-option value="4">4</md-option>
                <md-option value="5">5</md-option>
                <md-option value="6">6</md-option>
                </md-select>
              </md-field>
            </div>
            <div v-show="r1" class="md-layout">
              <md-field :class="messageClass('name', r1Data)">
                <label>Naziv poduzeća</label>
                <md-input type="text" required v-model="r1Data.name"/>
                <span class="md-error">Ovo polje je obavezno</span>
              </md-field>
              <md-field :class="messageClass('address', r1Data)">
                <label>Adresa</label>
                <md-input type="text" required v-model="r1Data.address"/>
                <span class="md-error">Ovo polje je obavezno</span>
              </md-field>
              <md-field :class="messageClass('city', r1Data)">
                <label>Grad</label>
                <md-input type="text" required v-model="r1Data.city"/>
                <span class="md-error">Ovo polje je obavezno</span>
              </md-field>
              <md-field :class="messageClass('postal_code', r1Data)">
                <label>Poštanski broj</label>
                <md-input type="text" required v-model="r1Data.postal_code"/>
                <span class="md-error">Ovo polje je obavezno</span>
              </md-field>
              <md-field :class="messageClass('oib', r1Data)">
                <label>OIB</label>
                <md-input type="text" required v-model="r1Data.oib"/>
                <span class="md-error">Ovo polje je obavezno</span>
              </md-field>
            </div>
            <md-dialog-actions>
              <md-button class="md-accent md-dense md-raised" v-on:click="setActivePopup(null)">Odustani</md-button>
              <md-button class="md-primary md-dense md-raised" v-on:click="setPaymentType($store.state.theatre.id)" v-if="seatAction == 'offline_checkout'">
                Naplati
              </md-button>
            </md-dialog-actions>
          </md-card-content>
        </md-card>
      </md-dialog>

      <md-dialog :md-active.sync="$store.state.dialogs.transactionDetails" class="seat-details md-scrollbar">
        <md-toolbar md-elevation="0">
          <md-button class="md-icon-button md-accent md-raised" v-on:click="$store.state.dialogs.transactionDetails = false">
            <md-icon>close</md-icon>
          </md-button>
          <h3 class="md-title">Detalji sjedala</h3>
        </md-toolbar>
        <md-table v-if="seatInfoVisible">
          <md-table-row>
            <md-table-head>ID</md-table-head>
            <md-table-head>Pretplata</md-table-head>
            <md-table-head>Nositelj</md-table-head>
            <md-table-head>Status</md-table-head>
            <md-table-head>Datum plaćanja</md-table-head>
            <md-table-head>Vrsta plaćanja</md-table-head>
            <md-table-head>Broj rata</md-table-head>
            <md-table-head>Cijena</md-table-head>
          </md-table-row>
          <md-table-row md-selectable="single" md-auto-select>
            <md-table-cell md-numeric>{{ $store.state.currentTransaction[0].id }}</md-table-cell>
            <md-table-cell>
              {{ $store.state.currentTransaction[0].data.subscription_title }} <strong>{{ $store.state.currentTransaction[0].data.subscription_number }}</strong>
            </md-table-cell>
            <md-table-cell>{{ getHolder($store.state.currentTransaction[0].data.subscribers) }}</md-table-cell>
            <md-table-cell>{{ getStatus($store.state.currentTransaction[0].status, $store.state.currentTransaction[0].data.is_cancelled) }}</md-table-cell>
            <md-table-cell>
              <span v-if="$store.state.currentTransaction[0].payment_date !== undefined">
                {{ $store.state.currentTransaction[0].payment_date }}.
              </span>
            </md-table-cell>
            <md-table-cell class="capitalize">
              {{ getPaymentType($store.state.currentTransaction[0].payment_type) }}
              <span v-if="$store.state.currentTransaction[0].payment_type == 'card'">
                /{{ $store.state.currentTransaction[0].card_type }}
              </span>
            </md-table-cell>
            <md-table-cell>{{ $store.state.currentTransaction[0].installments }}</md-table-cell>
            <md-table-cell>{{ formatCurrency($store.state.currentTransaction[0].amount) }}</md-table-cell>
              <md-button class="md-raised md-dense md-primary" v-on:click=" $store.state.dialogs.transactionDetails = false; detailsVisible = true; window.document.body.style.overflow = 'hidden'; pageY = window.pageYOffset; window.scrollTo(0,0)">
                Detalji
              </md-button>
          </md-table-row>
        </md-table>
        <div class="seat-list" v-if="seatInfoVisible">
          <h3>Sjedala u transakciji</h3>
          <div>
            <p v-for="value, seat in $store.state.currentTransaction[0].data.seats">
              {{ getSeatInfo(seat).title }} {{ getSeatInfo(seat).orientation }}<br>
              <b>Sjedalo</b> {{ getSeatInfo(seat).seatID }}, <b>red/loža</b> {{ getSeatInfo(seat).rowID }}
            </p>
          </div>
        </div>
      </md-dialog>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import SubscriberValidation from '../../mixins/subscriber-validator.js';
import FormatCurrency from '../../mixins/format-currency';
import PaymentType from '../../mixins/payment-type';


export default {
  name: 'SubscriptionTheatre',
  mixins: [FormatCurrency, PaymentType('fromTheatre')],
  data(){
    return {
      seatAction: null,
      steps:[false, false],
      selectedSubscriber: {},
      selectedPersonIndex: null,
      discount: false,
      detailsVisible: false,
      discountID: null,
      selectedSeats: [],
      hasDiscount: false,
      custom_discount: 0,
      userData: [{
        index: 0,
        city: '',
        address: '',
        last_name: '',
        first_name: '',
        postal_code: '',
        mobile_phone: '',
        email: '',
      }],
    }
  },


  methods:{
    addSubscriber(){
      this.userData.push({
        index: this.userData.length,
        city: '',
        address: '',
        last_name: '',
        first_name: '',
        postal_code: '',
        mobile_phone: '',
        email: ''
      })
    },

    getPricelistID(){
      if(!this.discount) return this.$store.state.receivedData.pricelists.list.filter(d =>{return d.web_price === false})[0].id
      else return this.$store.state.receivedData.pricelists.list.filter(d =>{return d.web_price === true})[0].id
    },

    populatePerson(index){
      this.selectedPersonIndex = index;
    },

    getPaymentType(paymentType){
      if(paymentType == 'cash') return 'Gotovina';
      else return ''
    },

    getSeatInfo(seat){
      let data = seat.split('-');
      let rowID = data[2];
      let rowCategory = `${data[0]}-${data[1]}`;
      return {
        orientation: seat.includes('-l-') ? 'Lijevo' : 'Desno',
        title: this.$store.state.rowIDs[rowCategory].title,
        position: this.$store.state.rowIDs[rowCategory].position,
        seatID: data[3],
        rowID: rowID,
      }
    },

    removeSubscriber(index){
      this.userData.splice(index, 1);
    },

    setActivePopup(index){
      let newSteps = [];
      this.steps.forEach((step, i) =>{
        if(i != index) newSteps.push(false);
        else newSteps.push(true);
      });
      this.steps = newSteps;

      if(index === null) this.abortTransaction();
    },


    async setTransaction(type, modal){
      this.selectedSeats = this.$store.getters.getSelectedSeats;
      this.seatAction = type;
      let context = {
        'adminCreate':true,
        'seat_updates':{
          'status': type,
          'seats': this.$store.getters.getSeatWithRow,
        },
        'status': type,
        'amount': this.$store.getters.getFullPrice(this.discount),
        'custom_discount': this.custom_discount / this.$store.getters.getFullPrice(this.discount)
      };

      this.selectedSeats.forEach((seat) =>{
        seat.person = {
          email: '',
          last_name: '',
          first_name: '',
          mobile_phone: '',
        }
      })

      this.discountID = this.$store.state.receivedData.pricelists.list.filter(d =>{return d.web_price === !this.discount})[0].id;

      if(this.$store.state.currentTab.tab == 'ticketTheatre') context['performance'] = this.$store.state.theatre.id
      else{
        context['subscription'] = this.$store.state.theatre.id;
        context['pricelist_id'] = this.discountID;
      }

      try{
        const response = await this.$store.dispatch('createTransaction', {context});
      } catch(e){
      }

      if(this.$store.state.createTransactionError === false){
        this.setActivePopup(modal);
      }
    },

    sendTransactionDetails(transactionType){
      let seats = [];
      let userData = [];
      this.userData.forEach((user, index) =>{
        if(index == 0) user.holder = true;
        if(user.isSelected) user.subscriber_id = user.id;

        // To remove subscriptions
        let dataToSend = JSON.parse(JSON.stringify(user));
        delete dataToSend.subscriptions
        userData.push(dataToSend)
      })

      this.requiredFields = ['first_name', 'last_name', 'address', 'city', 'postal_code', 'mobile_phone', 'email'];
      this.submited = true;
      this.objectsToValidate = userData;
      this.formSubmitted();

      if(this.passed){
        let context = {
          'seats': this.$store.getters.getSeatWithRow,
          'subscriber_data': userData,
        }

        if(this.$store.state.currentTab.tab == 'ticketTheatre') context['performance'] = this.$store.state.theatre.id;
        else context['subscription'] = this.$store.state.theatre.id;

        this.$store.dispatch('updateTransaction', {context});
        if(transactionType != 'reservation') this.setActivePopup(1);
        else{
          this.$store.dispatch('setActiveTab', 'transactionDetails');
          this.setActivePopup(-1);
        }
      }
    },

    abortTransaction(){
      let context = {
        'seat_updates':{
          'status': 'available',
          'seats': this.$store.getters.getSeatWithRow,
        },
        'status': 'aborted',
      }

      if(this.$store.state.currentTab.tab == 'ticketTheatre') context['performance'] = this.$store.state.theatre.id;
      else context['subscription'] = this.$store.state.theatre.id;

      this.$store.dispatch('updateTransaction', {context});
    },
  },

  computed:{
		...mapGetters([
      'getSelectedSeats',
      'getFullPrice',
      'isPageLoaded',
      'getStatus',
      'getHolder'
    ]),

    seatInfoVisible(){
      if(this.$store.state.currentTransaction !== null && this.$store.state.currentTransaction.length === undefined) this.$store.state.currentTransaction = [this.$store.state.currentTransaction]
      return this.$store.state.currentTransaction !== null && this.$store.state.currentTransaction !== undefined && this.$store.state.currentTransaction.length > 0 && this.$store.state.currentTransaction[0].hasOwnProperty('id')
    }
  },

  watch: {
    isPageLoaded(value){
      if(value){
        this.$store.state.isTicket = false;
      }
    },

    discount(value){
      if(value) this.discountID = this.$store.state.receivedData.pricelists.list.filter(d =>{return d.web_price === true})[0].id;
      else this.discountID = this.$store.state.receivedData.pricelists.list.filter(d =>{return d.web_price === false})[0].id;
    },

    selectedSubscriber(newValue, oldValue) {
      if(newValue !== null){
        this.userData.forEach((user, index) =>{
          if(user.index == this.selectedPersonIndex){
            let index = user.index;
            this.userData[index] = JSON.parse(JSON.stringify(newValue));
            this.userData[index].isSelected = true;
            this.userData[index].index = index;
            this.selectedSubscriber = null;
          }
        })
      }
    },

    getSelectedSeats(newValue, oldValue){
      let hasDiscount = false;
      for(let i = 0; i < newValue.length; i++){
        if(newValue[i].discount != newValue[i].price){
          hasDiscount = true;
          break;
        }
      }
      this.hasDiscount = hasDiscount;
      if(this.getSelectedSeats.length > 0){
        for(let seat of this.getSelectedSeats){
          if ( [117, 118].includes(this.$store.state.theatre.id) && this.getSelectedSeats.length > 2 && this.getSelectedSeats.indexOf(seat)>1){
            seat.price -=30;
          }
        }
      }

      if(this.discountID === null && this.$store.state.receivedData.pricelists.list.length > 0) this.$store.state.receivedData.pricelists.list.filter(d =>{return d.web_price === false})[0].id;
    },

    custom_discount: function (value) {
        // console.log(value);
        // this.discount = value
        // console.log(this.discount)
    }
  }
}
</script>


<style scoped lang="scss">
.add-subscriber{
  margin: 0;
}

.theatre-title{
  position: absolute;
  margin: 0;
  right: 50px;
}

.theatre-container{
  .back-button{
    top: -5px;
    left: -20px;
  }

  .selected-seats{
    top: 60px;
    right: 16px;

    .md-list{
      max-height: calc(100vh - 400px);
    }
  }
}

.seat-details{
  max-width: 1200px;
  width: 100%;
  overflow-y: scroll;
  .seat-list{
    padding: 50px 0 50px 24px;
    div{
      display: flex;
      flex-wrap: wrap;
    }
    h3{
      margin-bottom: 0;
    }
    p{
      margin: 35px 45px 0 0;
    }
  }
  .md-title{
    color: #000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/SubscriptionTheatre.vue